import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/discuss/course-cover.png';
var _hoisted_1 = {
  class: "choise-course"
};
var _hoisted_2 = {
  class: "choise-num"
};
var _hoisted_3 = {
  class: "course-info"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "author"
};
import { reactive, onMounted, inject } from 'vue';

/* api */
import { getContactCourse } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'ChoiseCourse',
  props: {
    checked: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disableId: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onlyNewCourse: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:checked'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var discussId = inject('discussId');
    var emit = __emit;
    var props = __props;
    var state = reactive({
      courseName: '',
      page: 1,
      courseList: [],
      checkedList: []
    });

    /* 事件 */
    var handleCheck = function handleCheck(isCheck, item) {
      var index = state.checkedList.findIndex(function (e) {
        return e.id === item.id;
      });
      if (isCheck) {
        index === -1 && state.checkedList.push(item);
      } else {
        index !== -1 && state.checkedList.splice(index, 1);
      }
      emit('update:checked', state.checkedList);
    };

    // 滚动加载
    var scrollHandle = function scrollHandle(e) {
      var _e$target = e.target,
        scrollTop = _e$target.scrollTop,
        clientHeight = _e$target.clientHeight,
        scrollHeight = _e$target.scrollHeight;
      if (scrollHeight - (scrollTop + clientHeight) <= 1) {
        state.page++;
        getCourseList(state.page);
      }
    };

    // 获取学程列表
    var getCourseList = function getCourseList() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      state.page = page;
      var data = {
        searchContent: state.courseName,
        current: page,
        size: 5
      };
      if (props.onlyNewCourse) {
        data.courseVersion = 2;
      }
      getContactCourse(discussId.value, data).then(function (res) {
        if (res.data.code === 0) {
          var _res$data$data;
          var list = ((_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.records) || [];
          var resList = list.map(function (e) {
            var cIds = state.checkedList.map(function (e) {
              return e.id;
            });
            var dIds = props.disableId;
            var isCheck = cIds.includes(e.id);
            var isDisable = dIds.includes(e.id);
            return {
              id: e.id,
              cover: e.cover,
              title: e.resourceName,
              author: e.creatorName,
              version: e.courseVersion,
              source: e.resourceSource,
              checked: isCheck,
              disabled: isDisable,
              dataJson: JSON.stringify(e)
            };
          });
          if (page === 1) {
            state.courseList = resList;
          } else {
            state.courseList = [].concat(_toConsumableArray(state.courseList), _toConsumableArray(resList));
          }
        }
      });
    };

    /* 钩子 */
    onMounted(function () {
      getCourseList();
    });
    return function (_ctx, _cache) {
      var _component_t_icon = _resolveComponent("t-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_checkbox = _resolveComponent("t-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_cache[2] || (_cache[2] = _createTextVNode(" 已选 ", -1)), _createElementVNode("i", null, _toDisplayString(state.checkedList.length), 1)]), _createVNode(_component_t_input, {
        modelValue: state.courseName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return state.courseName = $event;
        }),
        placeholder: "请输入学程名称"
      }, {
        suffixIcon: _withCtx(function () {
          return [_createVNode(_component_t_icon, {
            name: "search",
            class: "icon",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return getCourseList(1);
            })
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", {
        class: "course-list",
        onScroll: scrollHandle
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.courseList, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "course-item"
        }, [_createVNode(_component_t_checkbox, {
          modelValue: item.checked,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.checked = $event;
          },
          disabled: item.disabled,
          class: "checkbox",
          onChange: function onChange($event) {
            return handleCheck($event, item);
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]), _cache[4] || (_cache[4] = _createElementVNode("img", {
          class: "course-cover",
          src: _imports_0,
          alt: ""
        }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_5, [_cache[3] || (_cache[3] = _createElementVNode("span", null, "原创", -1)), _createElementVNode("span", null, _toDisplayString(item.author), 1)])])]);
      }), 128))], 32)]);
    };
  }
};